var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeeth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 56,
    viewBox: "0 0 201 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5959_28734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.7258 5.9375H88.778C94.3188 6.75688 95.821 9.90138 100.649 9.90138C105.478 9.90138 106.98 6.75688 112.522 5.9375H113.118C114.6 5.9375 116.067 6.2293 117.435 6.79623C118.804 7.36317 120.048 8.19414 121.095 9.2417C122.143 10.2893 122.974 11.5329 123.541 12.9016C124.108 14.2703 124.399 15.7373 124.399 17.2188V17.9621C124.399 21.4094 120.73 25.3448 119.649 29.0736C118.503 33.0327 117.719 36.2698 117.488 39.6554C116.948 47.5891 114.243 51.0625 111.337 51.0625C106.998 51.0625 103.146 33.2797 100.724 33.2797C98.3017 33.2797 93.4983 51.0625 89.9619 51.0625C87.8042 51.0625 85.01 49.7859 83.9603 39.6554C83.5423 35.625 82.8369 33.1799 81.6494 29.0736C80.6044 25.4636 77.0799 21.1506 76.8994 17.2793C76.8313 15.8152 77.0609 14.3525 77.5742 12.9797C78.0876 11.6068 78.8741 10.3524 79.8861 9.29216C80.8981 8.23196 82.1147 7.38803 83.4622 6.81143C84.8097 6.23483 86.2601 5.93752 87.7258 5.9375Z",
    stroke: "#60A5FA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5342 14.7998L110.15 21.1244M90.5342 21.1244L110.15 14.7998",
    stroke: "#60A5FA",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5959_28734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 56,
    fill: "white",
    transform: "translate(0.649414)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeeth);
export default __webpack_public_path__ + "static/media/Teeth.49edc92dc5de23004c46482fdd015d1f.svg";
export { ForwardRef as ReactComponent };